export function getPrice(canvasType, selectedSize, pieces) {
  const key = `${canvasType}-${selectedSize}`;

  const prices = {
    "1piece": {
      "print-70x50": 44.99,
      "print-80x60": 54.99,
      "print-100x70": 74.99,
      "print-120x80": 94.99,
      "print-140x80": 114.99,
      "stretched-70x50": 59.99,
      "stretched-80x60": 69.99,
      "stretched-100x70": 104.99,
      "stretched-120x80": 144.99,
      "stretched-140x80": 184.99,
      "framed-70x50": 224,
      "framed-80x60": 249,
      "framed-100x70": 284,
      "framed-120x80": 349,
      "framed-140x80": 349,
    },
    "3pieces": {
      "print-70x50": 119.99,
      "print-80x60": 129.99,
      "print-100x70": 139.99,
      "stretched-70x50": 154.99,
      "stretched-80x60": 174.99,
      "stretched-100x70": 274.99,
      "framed-70x50": 234.99,
      "framed-80x60": 264.99,
      "framed-100x70": 364.99,
    },
  };

  return prices[pieces]?.[key] || 89.99;
}
